<template>
  <BaseMain>
    <AppCookieBanner />
    <HeroSection :statistics="statistics" />
    <FeaturesSection />
  </BaseMain>
</template>

<script setup lang="ts">
import { HomeApi } from '~/features/Home/api/homeApi'
import FeaturesSection from '~/features/Home/components/FeaturesSection/FeaturesSection.vue'
import HeroSection from '~/features/Home/components/HeroSection.vue'

const { data: statistics, error } = await useAsyncData('statistics', () => HomeApi.getStatistics())

watch(error, (val) => {
  if (val) {
    showError(val)
  }
})
</script>
